import { SelectRoleSubjectProps } from "@components/role/select-role-utils";
import { SelectRole } from "@components/role/select-role";
import { FaroCoreApiConst, FaroCoreApiTypes } from "@stellar/core-api-client";

/** Renders a dropdown to select group role */
export function SelectGroupRole<T extends FaroCoreApiTypes.GroupRole>({
  selectedRole,
  onChange,
  variant,
  disabledRoles = [],
}: SelectRoleSubjectProps<T>): JSX.Element {
  function onSelectRoleChange(role: FaroCoreApiTypes.GroupRole): void {
    // TODO: Type assertion will be fixed in https://faro01.atlassian.net/browse/ST-1902
    onChange(role as T);
  }
  return (
    <SelectRole
      label="Role"
      roles={FaroCoreApiConst.allGroupRoles}
      disabledRoles={disabledRoles}
      variant={variant}
      selectedRole={selectedRole}
      onChange={onSelectRoleChange}
      link="workspaceRolesHelp"
      dataTestId="group-role-selector"
    />
  );
}
